<aside class="sidebar-menu" data-cy="sidebar-menu">
  <a
    [routerLink]="logoRoute()"
    (click)="onNavigate()"
    class="sidebar-logo"
    data-cy="sidebar-logo-link">
    <img [src]="logoSrc()" [alt]="logoAlt()" class="sidebar-logo__img" data-cy="sidebar-logo-img" />
  </a>

  <nav class="sidebar-nav" data-cy="sidebar-nav">
    @for (item of menuItems(); track item.id) {
      @if (item.hasGroup) {
        <ng-container *ngTemplateOutlet="groupTpl; context: { $implicit: item }"></ng-container>
      } @else {
        <a
          class="nav-item"
          [class.is-active]="isItemActive(item)"
          [class.is-disabled]="item.disabled"
          [routerLink]="item.disabled ? null : (item.route ?? '/')"
          (click)="!item.disabled && onNavigate()"
          [attr.aria-label]="item.label"
          [attr.aria-disabled]="item.disabled ? 'true' : null"
          [attr.aria-current]="isItemActive(item) ? 'page' : null"
          [attr.data-cy]="'sidebar-nav-item-' + item.id">
          <lkt-icon [name]="iconName(item.icon)" [size]="21" />
          <span class="nav-item__tip">{{ item.label }}</span>
        </a>
      }
    }
  </nav>

  @if (showViewSwitch() && viewSwitchSegments().length) {
    <lkt-view-switch
      class="sidebar-viewswitch"
      [collapsed]="true"
      [segments]="viewSwitchSegments()"
      [activeId]="viewSwitchActiveId()"
      (segmentClick)="onViewSwitchClick($event)"
      [dataCy]="'sidebar-viewswitch'" />
  }

  <div class="sidebar-footer" data-cy="sidebar-footer">
    <nz-divider data-cy="sidebar-divider" />

    @if (showNotifications()) {
      <button
        type="button"
        class="nav-item nav-item--action nav-item--bell"
        (click)="onNotificationsClick($event)"
        [attr.aria-label]="notificationsAriaLabel()"
        aria-haspopup="dialog"
        [attr.aria-expanded]="notificationsOpen()"
        data-cy="sidebar-notifications">
        <lkt-icon #bellIconRef class="nav-item__bell-icon" [name]="bellIcon" [size]="21" />
        @if (notificationsUnreadLabel()) {
          <!-- aria-hidden: a contagem já está no aria-label do botão, não repetir. -->
          <span class="nav-item__badge" aria-hidden="true">{{ notificationsUnreadLabel() }}</span>
        }
        <span class="nav-item__tip">Notificações</span>
      </button>
    }

    @for (item of helpMenuItems(); track item.id) {
      <ng-container *ngTemplateOutlet="groupTpl; context: { $implicit: item }"></ng-container>
    }

    <lkt-user-popover
      class="sidebar-user"
      [compact]="true"
      [userName]="userName()"
      [userAvatar]="userAvatar()"
      avatarSize="large"
      [profileLabel]="profileLabel()"
      [profileIcon]="profileIcon()"
      [hasMultipleProfiles]="hasMultipleProfiles()"
      [items]="userPopoverItems()"
      [version]="version()"
      [visible]="userPopoverOpen()"
      (itemClick)="onPopoverItemClick($event)"
      (switchProfileClick)="onSwitchProfile()"
      (visibleChange)="onUserPopoverVisibleChange($event)"
      data-cy="sidebar-user-popover" />
  </div>
</aside>

<ng-template #groupTpl let-item>
  <div
    class="nav-group"
    [class.is-open]="openGroupId() === item.id"
    [attr.data-cy]="'sidebar-nav-group-' + item.id">
    <button
      type="button"
      class="nav-item nav-item--group"
      [class.is-active]="isItemActive(item)"
      (click)="toggleGroup(item.id)"
      [attr.aria-label]="item.label"
      [attr.aria-expanded]="openGroupId() === item.id"
      [attr.data-cy]="'sidebar-nav-group-btn-' + item.id">
      <lkt-icon [name]="iconName(item.icon)" [size]="21" />
      <span class="nav-item__tip">{{ item.label }}</span>
    </button>

    @if (openGroupId() === item.id) {
      <div class="nav-subnav" [attr.data-cy]="'sidebar-subnav-' + item.id">
        @for (sub of item.routeGroup ?? []; track sub.route) {
          @if (isExternal(sub.route)) {
            <a
              class="nav-subitem"
              [href]="sub.route"
              target="_blank"
              rel="noopener noreferrer"
              [class.is-disabled]="sub.disabled"
              (click)="onNavigate()"
              [attr.data-cy]="'sidebar-subitem-' + sub.id">
              {{ sub.label }}
            </a>
          } @else {
            <a
              class="nav-subitem"
              [class.is-active]="isSubItemActive(sub.route)"
              [class.is-disabled]="sub.disabled"
              [routerLink]="sub.route"
              (click)="onNavigate()"
              [attr.data-cy]="'sidebar-subitem-' + sub.id">
              {{ sub.label }}
            </a>
          }
        }
      </div>
    }
  </div>
</ng-template>
